document
  .getElementById("newsletterForm")
  .addEventListener("submit", function (event) {
    event.preventDefault();
    var userEmail = document.getElementById("emailInput").value;
    document.getElementById("newsletterPopup").style.display = "block";
    document.getElementById("popupEmail").value = userEmail;
  });

document.getElementById("closePopup").addEventListener("click", function () {
  document.getElementById("newsletterPopup").style.display = "none";
});

document.getElementById("contact_form").addEventListener("submit", function () {
  var subscribeButton = document.getElementById("subscribeButton");
  var buttonText = document.getElementById("buttonText");
  var loadingIcon = document.getElementById("loadingIcon");

  buttonText.style.display = "none";
  loadingIcon.style.display = "inline";

  subscribeButton.disabled = true;
});

/* Newsletter Popup custom */
document
  .getElementById("contact_form")
  .addEventListener("submit", function (event) {
    if (document.getElementById("checkbox2").checked) {
      let input = document.createElement("input");
      input.type = "hidden";
      input.name = "contact[tags]";
      input.value = "GDPR NEWSLETTER, GDPR PROFILATO";
      this.appendChild(input);
    }
  });

document.getElementById("checkbox2").addEventListener("change", function () {
  if (this.checked) {
    document.getElementById("checkbox1").checked = true;
  }
});

/* Newsletter Popup theme version */

document
  .getElementById("contact_form")
  .addEventListener("submit", function (event) {
    if (document.getElementById("overlay_checkbox2").checked) {
      let input = document.createElement("input");
      input.type = "hidden";
      input.name = "contact[tags]";
      input.value = "GDPR NEWSLETTER, GDPR PROFILATO";
      this.appendChild(input);
    }
  });

document
  .getElementById("overlay_checkbox2")
  .addEventListener("change", function () {
    if (this.checked) {
      document.getElementById("overlay_checkbox1").checked = true;
    }
  });
